import { render } from "./Mas.vue?vue&type=template&id=c4527b1a"
import script from "./Mas.vue?vue&type=script&lang=js"
export * from "./Mas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__